<template>
  <div>
    <button @click="startRecording" :disabled="isRecording">开始录音</button>
    <button @click="stopRecording" :disabled="!isRecording">停止录音</button>
    <button @click="mergeSelectedRecordings">合并选定录音</button>
    <audio ref="audioPlayer" controls></audio>
    <ul>
      <li v-for="(recording, index) in recordings" :key="index">
        <input type="checkbox" v-model="selectedRecordings" :value="index" />
        <audio :src="recording" controls></audio>
      </li>
    </ul>
  </div>
</template>

<script>
// import FlvPlayer from 'ffmpeg.js/FlvPlayer';
export default {
  name: 'testPage',
  data() {
    return {
      isRecording: false,
      mediaRecorder: null,
      chunks: [],
      recordings: [],
      selectedRecordings: []
    };
  },
  methods: {
    startRecording() {
      navigator.mediaDevices.getUserMedia({ audio: true })
          .then((stream) => {
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.ondataavailable = (event) => {
              if (event.data.size > 0) {
                this.chunks.push(event.data);
              }
            };

            this.mediaRecorder.start();
            this.isRecording = true;
          })
          .catch((error) => {
            console.error('录音失败：' + error);
          });
    },
    stopRecording() {


      this.mediaRecorder.stop();
      this.isRecording = false;
      setTimeout(() => {
        if (this.chunks.length > 0) {
          const audioBlob = new Blob(this.chunks, { type: 'audio/wav' });
          const audioURL = URL.createObjectURL(audioBlob);
          this.recordings.push(audioURL);
          this.chunks = [];
        }
      },300)
    },
    async mergeSelectedRecordings() {
      // ...
      // Promise.all(selectedAudioBlobs)
      //     .then(async (blobs) => {
      //       const mergedBlob = new Blob(blobs, { type: 'audio/wav' });
      //       const audioURL = URL.createObjectURL(mergedBlob);
      //       this.recordings.push(audioURL);
      //       this.selectedRecordings = [];
      //
      //       // 更新播放器，或者您可以自定义其他处理方式
      //       this.$refs.audioPlayer.src = audioURL;
      //
      //       // 使用 ffmpeg.js 更新元数据
      //       const flvPlayer = FlvPlayer({
      //         type: 'getFlvMeta',
      //         fileData: mergedBlob,
      //       });
      //       await flvPlayer._load();
      //       const duration = flvPlayer.info.duration;
      //       console.log('合并后的录音时长：', duration);
      //
      //       // 添加一个下载链接
      //       const downloadLink = document.createElement('a');
      //       downloadLink.href = audioURL;
      //       downloadLink.download = 'merged-audio.wav';
      //       downloadLink.click();
      //     })
      //     .catch((error) => {
      //       console.error('合并错误：' + error);
      //     });
    },
  },
};
</script>
